import React, { createContext, useEffect, useReducer, useState } from 'react'
import * as Styles from './Lecture.style'
import Channeltem from '../Channeltem/Channeltem'
import HttpServer from '@/services/server'
import WKInfiniteScroll from '@/components/WKInfiniteScroll/WKInfiniteScroll'
import { SEARCH_TYPE, ILectureItem } from '@/services/Modules/searchServer'
interface IProps {
    keyword: string
    data: ILectureItem[]
}
const initPage = 2
export default function Lecture(props: IProps) {
    const [ isLoading, setIsloading ] = useState(false)
    const [ hasMore, setHasMore ] = useState(true)
    const [ list, setList ] = useState<ILectureItem[]>(props.data)
    const [ page, setPage ] = useState(initPage)
    const [ keyword, setKeyword ] =  useState(props.keyword)
    const size = 10

    if (!keyword) {
        return null
    }

    if (keyword !== props.keyword) {
        setKeyword(props.keyword)
        setList([])
        setHasMore(true)
        setPage(initPage)
    }

    const getList = async () => {
        console.log(page)
        try {
            setIsloading(true)
            const data = await HttpServer.getSearch<ILectureItem>({ keyword, type: SEARCH_TYPE.LECTURE, offset: (page - 1) * size})
            setList([...list, ...data.data.data.records])
            setHasMore(data.data.data.has_more)
            setIsloading(false)
        } catch (error) {
            console.log(error.message)
        }
    }

    function onBottom() {
        setPage(page + 1)
        getList()

    }

    return (
        <div className={Styles.container}>
            <div className={Styles.title}>
                <span className={Styles.bold}>课程</span>
                {/* <span className={Styles.right}>查看更多 <span className={Styles.arrow} /></span> */}
            </div>
            <div className={Styles.list}>
                {
                    list.map((item, index) => <Channeltem key={index} content={item} />)}
                <WKInfiniteScroll
                    onTouchBottom={onBottom} // 到达底部执行的方法
                    isStop={isLoading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
                    distance={200} // 距离底部多少px触发
                    isKill={!hasMore} // 不再监听滚动，一般是传!has_more
                    isShowLoading={true} // 请求数据的时候（isStop）是否显示菊花
                />
            </div>
        </div>
    )

}



// WEBPACK FOOTER //
// ./src/views/SearchResult/components/Lecture/Lecture.tsx